import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss']
})
export class ButtonToggleComponent implements OnInit {

  @Input() buttonValues: Array<{label: string, id: string}> = [];
  @Output() change = new EventEmitter<string | null>();

  selectedButtonId: string | null = null;

  ngOnInit(): void {
    this.selectedButtonId = this.buttonValues.length > 0 ? this.buttonValues[0].id : null;
  }

  selectButton(buttonId: string) {
    this.selectedButtonId = buttonId;
    this.change.emit(buttonId);
  }

  isSelected(buttonId: string): boolean {
    return this.selectedButtonId === buttonId;
  }


}
